module.exports = __webpack_public_path__ + "img/titanium-alloy.6d66e6e5.png";